import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callNoticeList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/board', data));
};

export const callNoticeInfo = async (idx) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/board/${idx}`));
};